import React from 'react';
import { MegaphoneIcon, MoonIcon, UserCheckIcon, UsersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { coordinators } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const icons: LucideIcon[] = [UsersIcon, UserCheckIcon, MegaphoneIcon, MoonIcon];
const tiles = ['bg-cta text-cta-ink', 'bg-sun text-ink', 'bg-violet text-white', 'bg-coral text-white'];

/** New in this landing: speaks to the coordinator who organizes several volunteer leaders */
export function CoordinatorSection() {
  return <section aria-labelledby="coordinators-title" className="bg-brand py-12 md:py-20" data-id="element-57" data-mp="21mykefv1duyc">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-58" data-mp="25pbeu84c26ft">
        <SectionHeading id="coordinators-title" tone="dark" eyebrow={coordinators.eyebrow} title={coordinators.title} sub={coordinators.sub} data-id="element-59" data-mp="25mp7a8hfzqxl" />

        <ul className="mx-auto mt-8 grid max-w-[980px] gap-3 sm:grid-cols-2 md:mt-10 md:gap-4" data-id="element-60" data-mp="3h3fh01l2r0vy">
          {coordinators.points.map((p, i) => {
          const Icon = icons[i % icons.length];
          return <li key={p.title} className="flex gap-4 rounded-xl bg-brand-dark p-5" data-id="element-61" data-mp="6gu05xy5o2il" data-mpi={i}>
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${tiles[i % tiles.length]}`} data-id="element-62" data-mp="1fxw9kdt0gd6">
                  <Icon className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" data-id="element-63" data-mp="3tjypw8174lwl" />
                </span>
                <div data-id="element-64" data-mp="3on0021okf147">
                  <p className="font-display text-[17px] font-extrabold leading-snug text-white" data-id="element-65" data-mp="3on8bdp51hyda">{p.title}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/80" data-id="element-66" data-mp="3evlr73aq4oye">{p.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 flex max-w-[420px] justify-center" data-id="element-67" data-mp="39yc5nyqggxfu">
          <CtaButton label={coordinators.cta} align="center" data-id="element-68" data-mp="35tw2w6c5264u" />
        </div>
      </div>
    </section>;
}